module.exports = __webpack_public_path__ + "static/media/Pochette Affliction.c95a2612.jpg";